import { render, staticRenderFns } from "./ScrollySvg.vue?vue&type=template&id=3fdd05b6&"
import script from "./ScrollySvg.vue?vue&type=script&lang=js&"
export * from "./ScrollySvg.vue?vue&type=script&lang=js&"
import style0 from "./ScrollySvg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports